import React, { useContext } from 'react';
import { ActionsCell, BaseCell } from '../Cells';
import FormGridContext from './FormGridContext';

const FormActionsCell = ({
  onEnterEdit,
  onExitEdit,
  onDelete,
  onDiscard,
  dataItem,
  editField,
  deleteField,
  formDataIndex,
  defaultInEdit,
  hidden = false,
  hideEditButton,
  useHandleRowSubmit,
  handleRowSubmit,
  isEditing,
  disabled,
  onSave,
  ...props
}) => {
  const formGridContext = useContext(FormGridContext);
  const itemContext = formGridContext[dataItem[formDataIndex]];
  const isDisabled = disabled || (isEditing && !dataItem[editField]);

  return (
    hidden ? <BaseCell />
      : (
        <ActionsCell
          dataItem={dataItem}
          editField={editField}
          deleteField={deleteField}
          onEnterEdit={onEnterEdit}
          onExitEdit={onExitEdit}
          onSave={(e) => {
            onSave?.(e);
            if (onExitEdit) {
              onExitEdit();
            }
            if (useHandleRowSubmit && handleRowSubmit) {
              handleRowSubmit(dataItem);
            } else {
              itemContext?.onSubmit(e);
            }
          }}
          onCancel={onDiscard}
          onDelete={onDelete}
          isLoading={itemContext?.isSubmitting}
          defaultInEdit={defaultInEdit}
          hideEditButton={hideEditButton}
          disabled={isDisabled}
          {...props}
        />
      )
  );
};

export default FormActionsCell;
